import { useAuth } from '@affiliate-cabinet/auth'

export const useGetLocalStorageKeyWithUserId = (localStorageKey: string) => {
  const {
    auth: { user },
  } = useAuth()

  return `${localStorageKey}-${user?.id}`
}
